<script setup>
import { ref, watch } from 'vue';

import { saveIcon, deleteIcon, undoIcon } from '../../utils/icons';

import DimensionesTest from "./DimensionesTest.vue";
import SeccionesTest from "./SeccionesTest.vue"; 
import LeyendasTest from "./LeyendasTest.vue";
import RespuestasTest from "./RespuestasTest.vue";
//import PreguntasTest from "./PreguntasTestPorSecciones.vue";
import PreguntasTest from "./PreguntasTest.vue";
import FiltrosTest from "./FiltrosTest.vue";

import { useTestStore } from '../../stores/TestStore';
const testStore = useTestStore();
//store.$reset()
const tipos = testStore.tipos;
const estados = testStore.estados;
const privacidades = testStore.privacidades;
const usos = testStore.usos;


const user_rol = document.getElementById("user_rol").value;
//const categorias = testStore.categorias;
const categorias = JSON.parse(document.getElementById("categorias").value);
const filtros = JSON.parse(document.getElementById("filtros").value);

const action = document.getElementById("action").value;

const eliminar_test = ref(false);


if(action == "new") {
  testStore.new_test(categorias[0].id);  
}else if (action == "edit") {
  testStore.edit_test(JSON.parse(document.getElementById("test").value));
}

const test = testStore.test;


// Tabs
const active_tab = ref("general");
function change_tab(tab) {
  active_tab.value = tab;
}

// Upload file
function select_poster_file(event) {
  testStore.inputPoster = event.target.files[0];
  test.poster = URL.createObjectURL(testStore.inputPoster);
}

// Watcher para los cambios en test
const unwatch = watch(test, () => { 
  testStore.do_test_changed();
}, {deep:true}
)


</script>

<template lang="">
  
  <div class="flex justify-between items-start mb-5">
    <div class="w-4/6">
    <h1 class="font-bold text-4xl mb-3">
      <span v-if="test.id" class="text-lg text-gray-400">#{{ test.id }}</span>
      {{ test.nombre }}
    </h1>
    <span class="text-lg font-bold text-gray-400"> {{ categorias.find((cat) => cat.id == test.categoria_id).nombre }} </span>
    <span class="ml-10 pill" :class="test.estado"> {{ estados.find((est) => est.value == test.estado).text }} </span>
    <span class="ml-10 text-gray-400" v-if="test.user">Creador:
      <span class="ml-2 font-bold text-black">{{ test.user }}</span>
    </span>
    
    </div>

    <nav class="flex justify-end space-x-4 w-3/6">
      <button :class="[testStore.test_changed ? 'button-text-icon' : 'button-text-icon disabled']" type="button" @click="testStore.save_test">
        <i v-html='saveIcon'></i><span class="mx-2">Guardar</span>
      </button>

      <a v-if="test.id" :href="'/tests/'+test.id+'/edit'" class="button-out" :class="[testStore.test_changed ? 'button-text-icon' : 'button-text-icon disabled']">
        <i v-html='undoIcon'></i>
      </a>
      
      <a v-if="test.id" :href="'/tests/'+test.id" class="button-out">Ver</a>
      <a href="/tests" class="button-out">Mis tests</a>
    </nav>
    
  </div>
  
  <div class="tabs-box">
    <button class="tab" :class="{ active: active_tab=='general'}" @click="change_tab('general')">General</button>
    <button class="tab" :class="{ active: active_tab=='resultados'}" @click="change_tab('resultados')">Resultados</button>
    <button class="tab" :class="{ active: active_tab=='dimensiones'}" @click="change_tab('dimensiones')">Dimensiones</button>
    <button class="tab" :class="{ active: active_tab=='secciones'}" @click="change_tab('secciones')" >Secciones</button>
    <button class="tab" :class="{ active: active_tab=='preguntas'}" @click="change_tab('preguntas')">Preguntas</button>
    <button class="tab" :class="{ active: active_tab=='respuestas'}" @click="change_tab('respuestas')">Respuestas</button>
    <button class="tab" :class="{ active: active_tab=='filtros'}" @click="change_tab('filtros')">Filtros</button>
  </div>

  <div class="tab-content" v-show="active_tab=='general'">

    <div class="general-test my-5 pb-10">

      <div class="flex flex-row space-x-4 my-5">
        <div class="basis-6/12">
          <h5 class="font-bold mb-2">Nombre</h5>
          <input v-model="test.nombre" type="text" placeholder="Nombre" class="input-f">
        </div>
       <div class="basis-3/12">
          <h5 class="font-bold mb-2">Categoría</h5>
          <select v-model="test.categoria_id" class="select-f">
            <option v-for="categoria in categorias" :value="categoria.id">{{ categoria.nombre }}</option>
          </select>
        </div>

        <div class="basis-3/12">
          <h5 class="font-bold mb-2">Estado</h5>
          <select v-model="test.estado" class="select-f">
            <option v-for="estado in estados" :value="estado.value">{{ estado.text }}</option>
          </select>
        </div>
 
      </div>
    

      <div class="flex flex-row space-x-4 my-5">
        <div class="basis-6/12">
          <h5 class="font-bold mb-2">Descripción</h5>
          <textarea class="textarea-f h-16" v-model="test.descripcion" type="text" placeholder="Descripción .."></textarea>
        </div>

        <div class="basis-2/12">         
          <h5 class="font-bold mb-2">Mostrar dimensiones</h5>
          <select v-model="test.dimensiones_show" class="select-f">
            <option value="false">No</option>
            <option value="true">Sí</option>
          </select>
        </div>

        <div class="basis-2/12">         
          <h5 class="font-bold mb-2">Mostrar secciones</h5>
          <select v-model="test.secciones_show" class="select-f">
            <option value="false">No</option>
            <option value="true">Sí</option>
          </select>
        </div>

        <div class="basis-2/12">         
          <h5 class="font-bold mb-2">Vista previa</h5>
          <select v-model="test.vista_previa" class="select-f">
            <option value="false">No</option>
            <option value="true">Sí</option>
          </select>
        </div>
      
      </div>
   
      <div class="my-5" v-if="user_rol == 'creador' || user_rol == 'creador_especialista'">
        <h5 class="font-bold mb-2">Privacidad  <span class="font-normal italic text-gray-600 ml-2">¿Quién puede utilizar este test?</span></h5>

        <div class="flex space-x-4">
          <div class="basis-4/12">
            <select v-model="test.privacidad" class="select-f">
              <option v-for="privacidad in privacidades" :value="privacidad.value">{{ privacidad.text }}</option>
            </select>
          </div>

          <div class="basis-8/12">
            <div class="explain border rounded p-2 bg-blue-100 text-sm">
              <span v-if="test.privacidad=='público'">Cualquier persona podrá ver este test y cualquier especialistas podrá copiarlo a su biblioteca para utilizarlo.</span>
              <span v-if="test.privacidad=='privado'">Solo tú podrás ver y utilizar este test</span>
              <span v-if="test.privacidad=='marketplace'">Solo podrá adquirirse a través del Marketplace</span>
            </div>
          </div>
          
        </div>
      </div>


      <div class="my-5" v-if="user_rol == 'especialista' || user_rol == 'creador_especialista'">
        
        <h5 class="font-bold mb-2">Uso del test <span class="font-normal italic text-gray-600 ml-2">¿Quién puede realizar las pruebas?</span></h5>
        
        <div class="flex space-x-4">
          <div class="basis-4/12">
            <select v-model="test.uso" class="select-f">
              <option v-for="uso in usos" :value="uso.value">{{ uso.text }}</option>
            </select>
          </div>
        
          <div class="basis-8/12">
            <div class="explain border rounded p-2 bg-blue-100 text-sm">
              <span v-if="test.uso=='público'">El test puede realizarse al publicarse en la plataforma aunque no se conozca el enlace privado.</span>
              <span v-if="test.uso=='privado_url' && test.uso_code == null">Solo aquellas personas que conozcan el enlace privado podrán realizarlo .</span>
              <span v-if="test.uso=='privado_url' && test.uso_code != null">Solo aquellas personas que conozcan el siguiente enlace podrán realizarlo</span>
              <span v-if="test.uso=='privado_password'">Además del enlace privado, se necesitará la siguiente contraseña para realizar el test.</span>
            </div>
          </div>
        </div>

        <div class="my-3 flex space-x-4" v-if="test.code != null">
          <div class="explain border rounded p-2 basis-8/12">
            Facilita el siguiente <b>enlace privado</b> a todas las personas que quieras que realicen el test: <br>
            <a :href="test.code_url" target="_blank" class="text-ur-red hover:underline text-lg my-2 font-bold block">{{ test.code_url }} </a>
          </div>

          <div class="explain border rounded p-2 basis-4/12 bg-red-100" v-if="test.uso=='privado_password'">
            <h5 class="font-bold mb-2">Contraseña</h5>
            <input v-model="test.uso_password" type="text" placeholder="Nombre" class="input-f">
          </div>
        </div>
            
      </div>

      <div class="my-5" v-if="test.id">
        <h5 class="font-bold mb-2">Póster</h5>
        
        <div class="flex justify-between">
          <div class="flex w-3/4">
            <div>
              <input type="file" @change="select_poster_file" class="block  px-3 py-2 mt-2 text-sm text-gray-600 bg-white border border-gray-200 rounded-lg file:bg-gray-200 file:text-gray-700 file:text-sm file:px-4 file:py-1 file:border-none file:rounded-full dark:file:bg-gray-800 dark:file:text-gray-200 dark:text-gray-300 placeholder-gray-400/70 dark:placeholder-gray-500 focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40 dark:border-gray-600 dark:bg-gray-900 dark:focus:border-blue-300" />
              <div class="text-sm text-gray-500 mt-1">Tamaño máximo: 5MB</div>
            </div>

            <button type="button" class="button-text-icon h-10 mt-3 ml-5" @click="testStore.upload_poster" v-if="testStore.inputPoster">
              <i v-html='saveIcon'></i><span class="mx-2">Subir poster</span>
            </button>
            
          </div>

          <button type="button" class="button-text-icon-gray-red h-10 mt-3 ml-5" @click="testStore.delete_poster">
            <i v-html='deleteIcon'></i><span class="mx-2">Eliminar poster</span>
          </button>
        </div>
        
        <div class="p-4 border mt-5 rounded" v-if="test.poster">
          <img :src="test.poster" class="h-48"/>
        </div>
      </div>

      <div class="my-5 mt-10 border-t-2 pt-5" v-if="test.id && test.estado == 'papelera' && !testStore.test_changed">
        <button v-if="!eliminar_test" class="button-text-icon-gray-red" type="button" @click="eliminar_test= !eliminar_test">
          <i v-html='deleteIcon'></i><span class="mx-2">Eliminar test definitivamente</span>
        </button>
        
        <div v-if="eliminar_test" class="flex space-x-4 items-center bg-red-100 p-4 border border-red-200">
          <div class="font-medium text-lg"> ¿Quieres eliminar el test? </div>
          <div class="button w-16" @click="testStore.delete_test"> Sí</div>
          <div class="button w-16" @click="eliminar_test= !eliminar_test"> No</div>
        </div>

        <div class="text-sm mt-3 text-gray-400">Solo se eliminarán los test que no tenga pruebas asociadas.</div>
      </div>

    </div>

  </div>


  <div class="tab-content" v-show="active_tab=='resultados'">

    <div class="flex space-x-4 my-5">
        
        <div class="basis-2/12">         
          <h5 class="font-bold mb-2">¿Resultado supervisado?</h5>
          <select v-model="test.tipo_resultado" class="select-f">
            <option value="inmediato">No</option>
            <option value="supervisado">Sí</option>
          </select>
        </div>

        <div class="explain border rounded p-3 my-4 bg-blue-100 text-sm mt-7" v-if="test.tipo_resultado == 'supervisado'">
          El resultado deberá ser supervisado por el especialista antes de ser publicado.
        </div>
        <div class="explain border rounded p-3 my-4 bg-blue-100 text-sm mt-7" v-else>
          El resultado se publica directamente en la web sin que el especialista lo supervise.
        </div>
    </div>

    <div class="general-test my-5 pb-10">
      <div class="explain border rounded p-3 my-4 bg-blue-100 text-sm">
        Envía une email con los resultados a cada participante. Para ello será necesario que actives el filtro <b>Email.</b><br>
        Puedes incluir código <b>html</b> en el cuerpo del mensaje para añadir links o resaltar el contenido.
      </div>

      <div class="flex space-x-4 my-5">
        
        <div class="basis-2/12">         
          <h5 class="font-bold mb-2">Enviar email con resultados</h5>
          <select v-model="test.send_email_result" class="select-f">
            <option value="false">No</option>
            <option value="true">Sí</option>
          </select>
        </div>

        <div class="basis-10/12">
          <h5 class="font-bold mb-2">Asunto del mensaje</h5>
          <input v-model="test.email_subject" type="text" placeholder="Asunto" class="input-f">
        </div>

      </div>

      <div class="my-5">
        <h5 class="font-bold mb-2">Cuerpo del mensaje</h5>
        <textarea class="textarea-f h-32" v-model="test.email_body" type="text" placeholder="Cuerpo del mensaje .."></textarea>
      </div>

    </div>

  </div>

  <div class="tab-content" v-show="active_tab=='dimensiones'">  
    <div class="explain border rounded p-3 my-4 bg-blue-100 text-sm">
      Configura las dimensiones o subescalas que tendrá tu test. <br><br>
      Las puntuaciones mínimas y máximas alcanzables para cada dimensión serán calculadas automáticamente en función de:
        <ul>
          <li><b>1)</b> Los pesos asignados a cada pregunta.</li>
          <li><b>2)</b> El modo de puntuación de cada pregunta.</li>
          <li><b>3)</b> Los puntos mínimos y máximos asignados a cada respuesta</li>
        </ul>
      
        <br>
      Puedes indicar <b>diagnósticos</b>
      <span class="inline-block mx-2">
      <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512">
        <path d="M123.6 391.3c12.9-9.4 29.6-11.8 44.6-6.4c26.5 9.6 56.2 15.1 87.8 15.1c124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 32 12.4 62.8 35.7 89.2c8.6 9.7 12.8 22.5 11.8 35.5c-1.4 18.1-5.7 34.7-11.3 49.4c17-7.9 31.1-16.7 39.4-22.7zM21.2 431.9c1.8-2.7 3.5-5.4 5.1-8.1c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6c-15.1 6.6-32.3 12.6-50.1 16.1c-.8 .2-1.6 .3-2.4 .5c-4.4 .8-8.7 1.5-13.2 1.9c-.2 0-.5 .1-.7 .1c-5.1 .5-10.2 .8-15.3 .8c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c4.1-4.2 7.8-8.7 11.3-13.5c1.7-2.3 3.3-4.6 4.8-6.9c.1-.2 .2-.3 .3-.5z"/>
      </svg>
      </span>
      para los rangos de valores que elijas. De esta forma podrás aportar un informe completo en el resultado final del test.
      
    </div>

    <DimensionesTest></DimensionesTest>
  </div>

  <div class="tab-content" v-show="active_tab=='secciones'">
    <div class="explain border rounded p-3 my-4 bg-blue-100 text-sm">
      Divide tu test en secciones para una mejor organización de las preguntas y respuestas.<br>
      No se puede <b>borrar una sección</b> si tiene preguntas, respuestas o leyendas asociadas.
    </div>
    <SeccionesTest></SeccionesTest>
  </div>

  <div class="tab-content" v-show="active_tab=='preguntas'">

    <div class="explain border rounded p-3 my-4 bg-blue-100 text-sm" v-if="!test.secciones || test.secciones.length == 0">
      Antes de introducir preguntas es necesario que crees al menos una sección.
    </div>

    <PreguntasTest></PreguntasTest>
  </div>

  <div class="tab-content" v-show="active_tab=='respuestas'">

    <div class="my-5">
      <h5 class="font-bold mb-2">¿Cómo quieres las respuestas?</h5>
      <select v-model="test.tipo" class="select-f">
        <option v-for="tipo in tipos" :value="tipo.value">{{ tipo.text }}</option>
        </select>
    </div>

    <div class="explain border rounded p-3 my-4 bg-blue-100 text-sm" v-if="!test.secciones || test.secciones.length == 0">
      Antes de introducir respuestas es necesario que crees al menos una sección.
    </div>



    <div class="explain border rounded p-3 my-4 bg-blue-100 text-sm" v-else>
      Puedes añadir a los test de puntuación numérica una leyenda para facilitar al encuestado su comprensión.

      <p v-if="test.tipo == 1">
        Todas las respuestas serán iguales para toda las secciones. 
        Puede cambiar esta configuración en <b>Tipo test</b> en la pestalla <b>General</b>
      </p>
    </div>

    <div v-if="test.tipo == 1">
      <LeyendasTest :seccion_id="0"></LeyendasTest>
      <RespuestasTest :seccion_id="0"></RespuestasTest>
    </div>


    <div v-if="test.tipo == 2">
      <div v-for="seccion in test.secciones" :key="seccion.id" class="mb-24">
        <h5 class="font-bold my-3 border p-2 bg-gray-200"><span class="text-gray-500 mr-2 ">Sección</span> {{seccion.nombre}}</h5>
        <LeyendasTest :seccion_id="seccion.id"></LeyendasTest>
        <RespuestasTest :seccion_id="seccion.id"></RespuestasTest>
      </div>
    </div>

  </div>

  <div class="tab-content" v-show="active_tab=='filtros'">
    
    <div class="explain border rounded p-3 my-4 bg-blue-100 text-sm">
      Los filtros permiten añadir información extra a tus tests para la explotación de los resultados.
    </div>
    
    <FiltrosTest></FiltrosTest>

  </div>

</template>

<style lang="scss">

</style>